import { Typography } from "@mui/material";
import CustomButton from "../CustomButton";
import React, { useEffect, useState } from "react";
import "../../pages/analytics/analytics.css";
import "./emptyState.css";
import { useAuth } from "../../context/API_Client";
import { customToast } from "../customToaster/customToast";
import ProductSettingsModal from "../../pages/paymentLink/productSettingsModal";

const EmptyState = ({
  image,
  mainText,
  subText,
  btnText,
  secondaryBtnText,
  btnFunction,
  secondaryBtnFunction,
  btnPermission,
  showCustomDropdownlist,
}) => {
  const { isAuthorizedPermission, updateCheckoutSettings, merchantSettings } =
    useAuth();
  const [toggalModal, setToggalModal] = useState(false);
  const [settings, setSettings] = useState();
  const [version, setVersion] = useState();
  const handCLickPrimary = () => {
    btnFunction();
  };
  const handleClickSecondary = () => {
    secondaryBtnFunction();
  };
  useEffect(() => {
    merchantSettings(
      (data) => {
        setSettings(data);
        setVersion(data?.version);
      },
      (errMsg) => {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  return (
    <div className="empty-root">
      <div className="empty-image-container">{image}</div>
      <div className="empty-text-container">
        <Typography
          className="bodyB1SemiBold"
          sx={{ color: "var(--text-high, rgba(1, 1, 2, 0.72))" }}
        >
          {mainText}
        </Typography>
        <Typography
          className="bodyB2RegularText"
          sx={{
            color: "var(--text-high, rgba(1, 1, 2, 0.72))",
            marginTop: "8px",
          }}
        >
          {subText}
        </Typography>
      </div>

      {isAuthorizedPermission(btnPermission) && (
        <div className="empty-state-butns">
          {secondaryBtnText && (
            <CustomButton
              variant={"outlined"}
              size={"md"}
              type={"primary"}
              text={secondaryBtnText}
              onClick={handleClickSecondary}
            />
          )}

          {showCustomDropdownlist && settings && (
            <div className="settingBtn">
              <CustomButton
                text={"Payment Link Settings"}
                buttonType="primary"
                buttonSize="md"
                buttonVariant="outlined"
                buttonId="settings-button"
                onClick={() => {
                  setToggalModal(true);
                }}
                iconButton={true}
              />
            </div>
          )}
          {btnText && (
            <CustomButton
              variant={"contained"}
              size={"md"}
              type={"primary"}
              text={btnText}
              onClick={handCLickPrimary}
            />
          )}
        </div>
      )}
      <ProductSettingsModal
        toggleDialog={toggalModal}
        filledBtnText={"Close"}
        filledBtnFunction={() => setToggalModal(false)}
      />
    </div>
  );
};

EmptyState.defaultProps = {
  image: <div></div>,
  mainText: "",
  subText: "",
  btnText: "",
  secondaryBtnText: "",
  btnFunction: () => { },
  secondaryBtnFunction: () => { },
  btnPermission: "",
  btnPermission2: "",
  showCustomDropdownlist: false,
};

export default EmptyState;
